/* Styles import */
import '@/assets/styles/_global.scss'
import '@/assets/styles/tailwind.css'
import 'vue-toastification/dist/index.css'
/* Plugin Configs import */
import '@/plugins/yupConfig'

import { createApp } from 'vue'

import App from '@/App.vue'
import plugins from '@/plugins'
import router from '@/router'
import store from '@/store'
import {
  showFailedNotification,
  showSuccessNotification,
  showWarningNotification
} from '@/utils/cosmeticsUtils'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(plugins)
app.mixin({
  methods: {
    showSuccessNotification,
    showFailedNotification,
    showWarningNotification
  }
})
app.mount('#app')
